import React, { useState, useRef, useEffect } from "react";

const S = {
  input:{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"9px 13px",color:"#e8edf5",fontSize:13,outline:"none",boxSizing:"border-box"},
  btn:{color:"#fff",border:"none",borderRadius:10,padding:"10px 24px",fontSize:13,fontWeight:600,cursor:"pointer"},
  card:{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,padding:"16px"},
  ghost:{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,color:"#aabbcc",cursor:"pointer",fontSize:12,padding:"7px 14px"},
};
const COLOR = "#9B59B6";

export default function CampaignAI({ user, onBack }) {
  const [tab, setTab] = useState("audit");
  const [files, setFiles] = useState({campaign:[],searchterm:[],ads:[]});
  const [result, setResult] = useState(null);
  const [status, setStatus] = useState("idle");
  const [log, setLog] = useState([]);
  const [productDesc, setProductDesc] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [chatting, setChatting] = useState(false);
  const [usage, setUsage] = useState({calls:0,tokens:0,costInr:0});
  const chatEndRef = useRef();

  useEffect(()=>{ chatEndRef.current?.scrollIntoView({behavior:"smooth"}); },[chatMessages]);

  const addLog = (msg,type="info") => setLog(p=>[...p,{msg,type}]);

  const addFile = (key,e) => { const f=Array.from(e.target.files||e); setFiles(p=>({...p,[key]:[...p[key],...f]})); };
  const removeFile = (key,i) => setFiles(p=>({...p,[key]:p[key].filter((_,j)=>j!==i)}));

  const analyze = async (type) => {
    setStatus("loading"); setLog([]); setResult(null);
    addLog(`Running ${type} analysis...`);
    const fd = new FormData();
    files.campaign.forEach(f=>fd.append("campaign",f));
    files.searchterm.forEach(f=>fd.append("searchterm",f));
    files.ads.forEach(f=>fd.append("ads",f));
    fd.append("analysisType", type);
    fd.append("productDescription", productDesc);
    fd.append("username", user);
    try {
      const res = await fetch("/api/campaign/analyze",{method:"POST",body:fd});
      const d = await res.json();
      if (!d.ok) throw new Error(d.error);
      setResult(d.result);
      if (d.usage) setUsage(u=>({calls:u.calls+1,tokens:u.tokens+(d.usage.inputTokens+d.usage.outputTokens),costInr:u.costInr+(d.usage.inputTokens*0.075/1e6+d.usage.outputTokens*0.30/1e6)*84}));
      addLog("✅ Analysis complete","success");
      setStatus("done");
    } catch(e) { addLog("❌ "+e.message,"error"); setStatus("error"); }
  };

  const sendChat = async () => {
    if (!chatInput.trim()||chatting) return;
    const msg = chatInput.trim(); setChatInput("");
    setChatMessages(m=>[...m,{role:"user",text:msg}]);
    setChatting(true);
    const context = result ? `Previous analysis result:\n${JSON.stringify(result,null,2)}` : "";
    try {
      const res = await fetch("/api/campaign/chat",{
        method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify({message:msg, context, history:chatMessages, username:user}),
      });
      const d = await res.json();
      if (!d.ok) throw new Error(d.error);
      setChatMessages(m=>[...m,{role:"ai",text:d.reply}]);
      if (d.usage) setUsage(u=>({calls:u.calls+1,tokens:u.tokens+(d.usage.inputTokens+d.usage.outputTokens),costInr:u.costInr+(d.usage.inputTokens*0.075/1e6+d.usage.outputTokens*0.30/1e6)*84}));
    } catch(e) { setChatMessages(m=>[...m,{role:"error",text:"❌ "+e.message}]); }
    setChatting(false);
  };

  const actionColor = (a) => ({SCALE:"#27AE60",PAUSE:"#E74C3C",OPTIMISE:"#F39C12",KEEP:"#4A9FD4",ADD_EXACT:"#27AE60",ADD_PHRASE:"#4A9FD4",ADD_NEGATIVE:"#E74C3C",MONITOR:"#F39C12"}[a]||"#8899aa");

  const ZONES = [
    {id:"campaign",  label:"Campaign Report",    accept:".csv", hint:"Campaign_report.csv"},
    {id:"searchterm",label:"Search Term Report", accept:".xlsx",hint:"Search_term_report.xlsx"},
    {id:"ads",       label:"Ads Product Report", accept:".xlsx",hint:"Advertised_product_report.xlsx"},
  ];

  return (
    <div style={{minHeight:"100vh",background:"#0a0f1e",color:"#e8edf5",fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{maxWidth:1200,margin:"0 auto",padding:"32px 16px"}}>

        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <button style={S.ghost} onClick={onBack}>← Dashboard</button>
            <div style={{color:COLOR,fontWeight:700,fontSize:18}}>🤖 Campaign AI</div>
          </div>
          {usage.calls>0&&(
            <div style={{background:"rgba(155,89,182,0.1)",border:"1px solid rgba(155,89,182,0.2)",borderRadius:8,padding:"6px 12px",fontSize:11}}>
              <span style={{color:COLOR,fontWeight:700}}>Usage: </span>
              <span style={{color:"#aabbcc"}}>{usage.calls} calls · {usage.tokens.toLocaleString()} tokens · </span>
              <span style={{color:"#F39C12",fontWeight:700}}>₹{usage.costInr.toFixed(4)}</span>
            </div>
          )}
        </div>

        {/* Tabs */}
        <div style={{display:"flex",gap:8,marginBottom:20,flexWrap:"wrap"}}>
          {[["audit","📋 Campaign Audit"],["keywords","🔑 Keyword Harvesting"],["structure","🏗️ Campaign Structure"],["chat","💬 Performance Chat"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)}
              style={{padding:"8px 16px",borderRadius:20,border:"1px solid",cursor:"pointer",fontSize:12,fontWeight:600,
                background:tab===id?"rgba(155,89,182,0.2)":"rgba(255,255,255,0.04)",
                borderColor:tab===id?COLOR:"rgba(255,255,255,0.1)",
                color:tab===id?COLOR:"#8899aa"}}>{label}</button>
          ))}
        </div>

        <div style={{display:"grid",gridTemplateColumns:tab==="chat"?"1fr":"1fr 1fr",gap:16}}>

          {/* Left: Input */}
          {tab !== "chat" && (
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {tab !== "structure" && ZONES.map(z=>(
                <div key={z.id} style={S.card}>
                  <div style={{color:"#e8edf5",fontWeight:600,fontSize:13,marginBottom:8}}>{z.label}</div>
                  <label style={{display:"block",border:"2px dashed rgba(255,255,255,0.1)",borderRadius:8,padding:"12px",cursor:"pointer",textAlign:"center",marginBottom:8}}>
                    <input type="file" accept={z.accept} multiple style={{display:"none"}} onChange={e=>addFile(z.id,e)}/>
                    <div style={{color:"#8899aa",fontSize:12}}>Click to upload · {z.hint}</div>
                  </label>
                  {files[z.id].map((f,i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",background:"rgba(255,255,255,0.04)",borderRadius:5,padding:"4px 8px",fontSize:11}}>
                      <span style={{color:"#aaccdd"}}>{f.name}</span>
                      <button onClick={()=>removeFile(z.id,i)} style={{background:"none",border:"none",color:"#FF6B6B",cursor:"pointer"}}>×</button>
                    </div>
                  ))}
                </div>
              ))}

              {tab === "structure" && (
                <div style={S.card}>
                  <div style={{color:"#e8edf5",fontWeight:600,fontSize:13,marginBottom:8}}>Product Description</div>
                  <textarea style={{...S.input,resize:"vertical",fontSize:12,minHeight:120}}
                    placeholder="Describe your product, target audience, main keywords, price range, and any specific goals..."
                    value={productDesc} onChange={e=>setProductDesc(e.target.value)}/>
                </div>
              )}

              <button style={{...S.btn,background:`linear-gradient(135deg,#6C3483,${COLOR})`,
                opacity:status==="loading"?0.6:1}}
                onClick={()=>analyze(tab)} disabled={status==="loading"}>
                {status==="loading"?"⟳ Analysing...":`🤖 Run ${tab==="audit"?"Audit":tab==="keywords"?"Keyword Analysis":tab==="structure"?"Structure Builder":""}`}
              </button>

              {log.length>0&&(
                <div style={{background:"rgba(0,0,0,0.3)",borderRadius:8,padding:"10px",fontFamily:"monospace",fontSize:11}}>
                  {log.map((l,i)=><div key={i} style={{color:l.type==="success"?"#4CAF82":l.type==="error"?"#FF6B6B":"#8BB8D4",marginBottom:2}}>› {l.msg}</div>)}
                </div>
              )}
            </div>
          )}

          {/* Right/Full: Results */}
          <div style={{...(tab==="chat"?{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}:{})}}>

            {/* Results panel */}
            {tab !== "chat" && (
              <div style={S.card}>
                {!result ? (
                  <div style={{textAlign:"center",padding:"48px 0",color:"#667788"}}>
                    <div style={{fontSize:32,marginBottom:8}}>🤖</div>
                    <div>Run analysis to see results</div>
                  </div>
                ) : (
                  <div style={{maxHeight:600,overflowY:"auto"}}>
                    {/* Audit results */}
                    {tab==="audit" && Array.isArray(result) && result.map((r,i)=>(
                      <div key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"10px 0"}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                          <span style={{color:"#e8edf5",fontSize:12,fontWeight:600,flex:1}}>{r.campaign}</span>
                          <span style={{color:actionColor(r.action),fontWeight:700,fontSize:11,padding:"2px 8px",border:`1px solid ${actionColor(r.action)}44`,borderRadius:10,marginLeft:8}}>{r.action}</span>
                          <span style={{color:r.priority==="high"?"#E74C3C":r.priority==="medium"?"#F39C12":"#27AE60",fontSize:10,marginLeft:6}}>{r.priority}</span>
                        </div>
                        <div style={{color:"#aabbcc",fontSize:11,marginBottom:2}}>{r.reason}</div>
                        <div style={{color:"#667788",fontSize:10}}>{r.suggestion}</div>
                      </div>
                    ))}

                    {/* Keywords results */}
                    {tab==="keywords" && Array.isArray(result) && result.map((r,i)=>(
                      <div key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"8px 0"}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                          <span style={{color:"#e8edf5",fontSize:12,fontWeight:600}}>{r.term}</span>
                          <span style={{color:actionColor(r.action),fontWeight:700,fontSize:10,padding:"2px 8px",border:`1px solid ${actionColor(r.action)}44`,borderRadius:10}}>{r.action}</span>
                        </div>
                        <div style={{color:"#aabbcc",fontSize:11}}>Ad Group: {r.adGroup} · Bid: ₹{r.suggestedBid}</div>
                        <div style={{color:"#667788",fontSize:10}}>{r.reason}</div>
                      </div>
                    ))}

                    {/* Structure results */}
                    {tab==="structure" && result.campaigns && result.campaigns.map((c,i)=>(
                      <div key={i} style={{background:"rgba(155,89,182,0.06)",border:"1px solid rgba(155,89,182,0.15)",borderRadius:8,padding:"12px",marginBottom:10}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                          <span style={{color:COLOR,fontWeight:700,fontSize:13}}>{c.name}</span>
                          <span style={{color:"#aabbcc",fontSize:11}}>{c.type} · ₹{c.budget}/day</span>
                        </div>
                        <div style={{color:"#8899aa",fontSize:11,marginBottom:8}}>Strategy: {c.biddingStrategy}</div>
                        {c.adGroups?.map((ag,j)=>(
                          <div key={j} style={{background:"rgba(255,255,255,0.04)",borderRadius:6,padding:"8px",marginBottom:6}}>
                            <div style={{color:"#e8edf5",fontSize:11,fontWeight:600,marginBottom:2}}>{ag.name}</div>
                            <div style={{color:"#667788",fontSize:10}}>Targeting: {ag.targeting} · Match: {ag.matchType} · Bid: ₹{ag.suggestedBid}</div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Chat */}
            {tab==="chat" && (
              <>
                {/* File upload for chat context */}
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  <div style={{color:"#e8edf5",fontWeight:600,fontSize:13,marginBottom:4}}>Upload Data for Context</div>
                  {ZONES.map(z=>(
                    <div key={z.id} style={S.card}>
                      <div style={{color:"#aabbcc",fontSize:12,marginBottom:6}}>{z.label}</div>
                      <label style={{display:"block",border:"2px dashed rgba(255,255,255,0.08)",borderRadius:6,padding:"8px",cursor:"pointer",textAlign:"center"}}>
                        <input type="file" accept={z.accept} multiple style={{display:"none"}} onChange={e=>addFile(z.id,e)}/>
                        <div style={{color:"#667788",fontSize:11}}>{files[z.id].length>0?`${files[z.id].length} file(s) loaded`:"Click to upload"}</div>
                      </label>
                    </div>
                  ))}
                </div>

                {/* Chat window */}
                <div style={{...S.card,display:"flex",flexDirection:"column",height:500}}>
                  <div style={{color:"#e8edf5",fontWeight:700,fontSize:13,marginBottom:10,borderBottom:"1px solid rgba(255,255,255,0.07)",paddingBottom:10}}>
                    💬 Performance Chat
                  </div>
                  <div style={{flex:1,overflowY:"auto",display:"flex",flexDirection:"column",gap:8,marginBottom:10}}>
                    {chatMessages.length===0&&(
                      <div style={{color:"#445566",fontSize:12,textAlign:"center",padding:"20px 0"}}>
                        Ask anything about your campaign performance.<br/>
                        <span style={{fontSize:11,color:"#334455"}}>
                          "Why is my ACOS high?" · "Which campaigns to pause?" · "How to structure my keywords?"
                        </span>
                      </div>
                    )}
                    {chatMessages.map((m,i)=>(
                      <div key={i} style={{padding:"10px 12px",borderRadius:8,fontSize:12.5,lineHeight:1.7,
                        background:m.role==="user"?"rgba(155,89,182,0.12)":m.role==="error"?"rgba(255,107,107,0.1)":"rgba(255,255,255,0.06)",
                        color:m.role==="user"?COLOR:m.role==="error"?"#FF6B6B":"#e0e8f0",
                        alignSelf:m.role==="user"?"flex-end":"flex-start",maxWidth:"95%",
                        borderLeft:m.role==="ai"?"3px solid rgba(155,89,182,0.5)":"none"}}>
                        {m.role==="user"&&<span style={{fontSize:10,color:COLOR+"bb",display:"block",marginBottom:2}}>You</span>}
                        {m.role==="ai"&&<span style={{fontSize:10,color:"#c9a8f0",display:"block",marginBottom:2}}>Campaign AI</span>}
                        <span style={{whiteSpace:"pre-wrap"}}>{m.text}</span>
                      </div>
                    ))}
                    {chatting&&<div style={{padding:"8px 12px",borderRadius:8,fontSize:12,color:"#c9a8f0",background:"rgba(255,255,255,0.04)",borderLeft:"3px solid rgba(155,89,182,0.5)"}}>⟳ Thinking...</div>}
                    <div ref={chatEndRef}/>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <textarea style={{...S.input,resize:"none",flex:1,minHeight:52,fontSize:12}}
                      placeholder="Ask about your campaign performance..."
                      value={chatInput} onChange={e=>setChatInput(e.target.value)}
                      onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendChat();}}}/>
                    <button style={{...S.btn,background:`linear-gradient(135deg,#6C3483,${COLOR})`,padding:"8px 14px",alignSelf:"flex-end",...(chatting?{opacity:0.6,cursor:"not-allowed"}:{})}}
                      onClick={sendChat} disabled={chatting}>↑</button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
